import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundProcedureTherapies} from '../services/getRefundProcedureTherapies';
import type {GetRefundProcedureTherapiesParams} from 'domain/usecases/private/refund/request/get-procedure-therapies';

export const useGetRefundProcedureTherapiesQuery = (params?: GetRefundProcedureTherapiesParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_PROCEDURE_THERAPIES, params],
		queryFn: ({signal}) => getRefundProcedureTherapies({...params, signal}),
		retry: 3,
	});
